<template>
    <div>
        <!-- Ver Adiantamentos -->
        <div class="modal fade" id="adiantamentosValoresModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Particulares</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="dados">
                            <table class="table table-hover table-sm small">
                                <thead>
                                    <tr>
                                        <th>Paciente</th>
                                        <th>Procedimentos</th>
                                        <th class="text-right">Valor</th>
                                        <th class="text-right">Pago</th>
                                        <th class="text-right">Adiantamentos</th>
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    <tr v-for="(lista, index) in dados" :key="index">
                                        <td>
                                            {{ lista[0].nome_paciente }}
                                            <div class="small text-muted">
                                                {{ lista[0].plano.search }}
                                            </div>
                                        </td>
                                        <td>
                                            <div v-for="(marcacao, imx) in lista" :key="imx">
                                                {{ marcacao.procedimento ? marcacao.procedimento.search : '-' }}
                                                <span v-if="marcacao.outros_proc" class="badge badge-primary">
                                                    <i class="fa-solid fa-plus"></i>
                                                    {{ marcacao.outros_proc }}
                                                </span>

                                                <span class="small text-muted ml-1">
                                                    (M{{ marcacao.id_marcacao }})
                                                </span>

                                                <span class="small text-muted ml-1" v-if="marcacao.id_orcamento">
                                                    (Orc: {{ marcacao.id_orcamento }})
                                                </span>
                                            </div>
                                        </td>
                                        <td class="text-right">{{ $util.formatMoeda(lista.reduce((total, item) => total + parseFloat(item.dc_valor_previsto || 0), 0)) }}</td>
                                        <td class="text-right">
                                            {{ $util.formatMoeda(lista.reduce((total, item) => total + ( ( item.orcamento && item.orcamento.pagamento && item.orcamento.pagamento.valor_total_pago ) ? parseFloat(item.orcamento.pagamento.valor_total_pago.total, 0) : 0), 0)) }}
                                        </td>
                                        <td class="text-right">
                                            <template v-if="lista[0].id_paciente">
                                                {{ $util.formatMoeda(lista[0].paciente.adiantamentos.reduce((total, item) => total + parseFloat(item.saldo_adiantamento || 0), 0)) }}
                                            </template>

                                            <template v-else-if="lista[0].id_cadastro_temporario">
                                                {{ $util.formatMoeda(lista[0].cadastro_temporario.adiantamentos.reduce((total, item) => total + parseFloat(item.saldo_adiantamento || 0), 0)) }}
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery'; 

export default {
    data() { 
        return { 
            dados: null, 
        };
    },

    methods: { 
        abrir(id_marcacoes) { 

            this.dados = null;
            $('#adiantamentosValoresModal').modal('show');

            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'get_valores_adiantamentos', 
                parms: { 
                    id_marcacoes: id_marcacoes 
                }, 
                loadTo: res => { 
                    if ( res.lista && res.lista.length ) { 
                        console.log(res.lista);

                        this.dados = _.groupBy(res.lista, item => { 
                            if ( item.id_paciente ) { 
                                return 'P' + item.id_paciente;
                            } else { 
                                return 'T' + item.id_cadastro_temporario;
                            }
                        });
                    }
                }
            });

        }
    }
}
</script>